document.addEventListener('DOMContentLoaded', function() {
  const descriptionDiv = document.querySelector('.description.rte');
  const variantInput = document.querySelector('[name="id"]');
  if (!variantInput || !descriptionDiv) return;

  function updateDescription() {
    const variantId = variantInput.value;
    const text = window.variantTexts && window.variantTexts[variantId];
    if (text) {
      descriptionDiv.innerHTML = text;
    }
  }

  // Écoute tous les événements possibles
  variantInput.addEventListener('change', updateDescription);
  document.addEventListener('variant:changed', updateDescription);
  document.addEventListener('variantChange', updateDescription);

  // Observer les changements de valeur
  const observer = new MutationObserver(updateDescription);
  observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

  updateDescription();
});
